import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cue-modal-body',
  templateUrl: './modal-body.component.html',
  styleUrls: ['./modal-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ModalBodyComponent {}
